import { useState } from "react";

const photos = [
  { id: 1, src: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/942cac6ab89dcab6417d4154bccde99e.jpeg", alt: "Custom Chopper" },
  { id: 2, src: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/cf44794596896ff39e6aeacdab88e2d0.jpeg", alt: "Group Ride" },
  { id: 3, src: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/aad1a2607a202686105e71b01d398e28.jpeg", alt: "Club Patch" },
  { id: 4, src: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/7dd7f55fce6b3acc046894e1c1773954.jpeg", alt: "Night Rally" },
  { id: 5, src: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/ea59a86de3c1bc5c08556cef522557d1.jpeg", alt: "Sunset Ride" },
  { id: 6, src: "https://public.readdy.ai/ai/img_res/f093a82d-f7f3-434e-824e-2116029f934c.png", alt: "Charity Toy Run" },
  { id: 7, src: "https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/cb6ce31db01572c0164b6ba2552c7b08.jpeg", alt: "Member Portrait" },
  { id: 8, src: "https://public.readdy.ai/ai/img_res/3130b773-010a-4014-89b2-759deb7d4723.png", alt: "Bike Show" },
];

export default function GallerySection() {
  const [selected, setSelected] = useState<null | { src: string; alt: string }>(null);

  return (
    <section id="gallery" className="w-full bg-[#111111] py-24 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <p className="text-red-500 uppercase tracking-[0.3em] text-xs font-bold mb-3">The Life</p>
          <h2 className="text-4xl md:text-5xl font-black text-white uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
            Photo Gallery
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {photos.map((photo) => (
            <div
              key={photo.id}
              className="overflow-hidden cursor-pointer group relative"
              onClick={() => setSelected(photo)}
            >
              <div className="w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-zoom-in-line text-white text-2xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selected && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelected(null)}
        >
          <button
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setSelected(null)}
          >
            <i className="ri-close-line text-3xl"></i>
          </button>
          <img
            src={selected.src}
            alt={selected.alt}
            className="max-w-4xl w-full max-h-[80vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
